import { useEffect, useRef } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export const JobTracker = () => {
  const qc = useQueryClient();
  const { data = [] } = useQuery({
    queryKey: ["jobs"],
    queryFn: () => api.get("/jobs").then((r) => r.data),
    refetchInterval: (q) => ((q.state.data || []).some((j) => j.status === "running") ? 2000 : 15000),
  });
  const running = data.filter((j) => j.status === "running");
  const prev = useRef(0);
  useEffect(() => {
    if (prev.current > running.length) qc.invalidateQueries();
    prev.current = running.length;
  }, [running.length, qc]);
  if (!running.length) return null;
  const j = running[0];
  const pct = Math.round((j.done / Math.max(1, j.total)) * 100);
  return (
    <div data-testid="job-tracker" className="hidden sm:flex items-center gap-2 text-xs border border-blue-600/40 bg-blue-600/10 rounded-md px-3 py-1.5">
      <Loader2 className="h-3.5 w-3.5 animate-spin text-blue-400" />
      <span className="text-slate-300 max-w-[180px] truncate">{j.label}</span>
      <span className="font-mono text-blue-300" data-testid="job-progress">{j.done}/{j.total} · {pct}%</span>
    </div>
  );
};
